import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import { ThemeContext } from "kreate-common/modules/kreate-ui/components/ThemeProvider/config";
import React from "react";

import ButtonAdd from "../../../NavbarV2/components/ButtonAdd";
import ButtonSwitchTheme from "../../../NavbarV2/components/ButtonSwitchTheme";
import ButtonUserFusedWithButtonWallet from "../../../NavbarV2/components/ButtonUserFusedWithButtonWallet";
import ProductSwitcher from "../../../NavbarV2/components/ProductSwitcher";

import ButtonExplore from "./components/ButtonExplore";
import ButtonHamburgerV2 from "./components/ButtonHamburgerV2";
import ButtonSearch from "./components/ButtonSearch";
import LinkToProductPageWithKreateLogo from "./components/LinkToProductPageWithKreateLogo";
import SearchBar from "./components/SearchBar";
import styles from "./index.module.scss";

const BACKGROUND = {
  transparent: styles.background_transparent,
  solid: styles.background_solid,
};

function ContentOnMobile({
  className,
  style,
  hideSearchBar,
}: {
  className?: string;
  style?: React.CSSProperties;
  hideSearchBar?: boolean;
}) {
  return (
    <div className={cx(styles.content, className)} style={style}>
      <Flex.Row alignItems="center" gap="16px">
        <LinkToProductPageWithKreateLogo product="market" />
        <ProductSwitcher product="market" />
      </Flex.Row>
      <Flex.Row alignItems="center" gap="12px">
        {!hideSearchBar ? <ButtonSearch /> : undefined}
        <ButtonUserFusedWithButtonWallet />
        <ButtonHamburgerV2
          features={[
            "add-artwork",
            "add-collection",
            "separator",
            "explore-marketplace",
            "separator",
            "switch-theme",
          ]}
        />
      </Flex.Row>
    </div>
  );
}

function ContentOnDesktop({
  className,
  style,
  hideSearchBar,
}: {
  className?: string;
  style?: React.CSSProperties;
  hideSearchBar?: boolean;
}) {
  const theme = React.useContext(ThemeContext);

  return (
    <div className={cx(styles.content, className)} style={style}>
      <Flex.Row alignItems="center" gap="16px">
        <LinkToProductPageWithKreateLogo product="market" />
        <ProductSwitcher product="market" />
      </Flex.Row>
      {!hideSearchBar ? (
        <Flex.Cell flex="1 0 auto" minWidth="0" asChild>
          <SearchBar />
        </Flex.Cell>
      ) : undefined}
      <Flex.Row alignItems="center" gap="12px">
        <ButtonExplore />
        <ButtonUserFusedWithButtonWallet />
        <ButtonAdd />
        {theme !== "default" ? <ButtonSwitchTheme /> : null}
      </Flex.Row>
    </div>
  );
}

function Root({
  className,
  style,
  background,
  hideSearchBar,
}: {
  className?: string;
  style?: React.CSSProperties;
  background: keyof typeof BACKGROUND;
  hideSearchBar?: boolean;
}) {
  return (
    <div
      className={cx(styles.root, className, BACKGROUND[background])}
      style={style}
    >
      <ContentOnMobile
        className={styles.visibleOnlyOnMobile}
        hideSearchBar={hideSearchBar}
      />
      <ContentOnDesktop
        className={styles.visibleOnlyOnDesktop}
        hideSearchBar={hideSearchBar}
      />
    </div>
  );
}

const NavbarOnly$Market = Root;

export default NavbarOnly$Market;
